import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';

import ToasterComponent from 'shared/components/ToasterComponent';
import Fabrication from 'offshore_pcb/pcb_fabrication/Fabrication';
import Project from 'offshore_pcb/project/Project';
import Assembly from 'shared/product_tabs/tab_assembly/Assembly';
import Stencils from 'shared/product_tabs/tab_stencils/Stencils';
import Accessories from 'shared/product_tabs/tab_accessories/Accessories';
import Parts from 'shared/product_tabs/tab_parts/Parts';

import { changeGlobalParameter } from 'shared/product_tabs/tab_project/actions/changeGlobalParameter';
import { changeTab } from 'shared/product_tabs/tabs/tabSlice';
import { selectActiveTab } from 'shared/product_tabs/tabs/selector';
import { processTabChange as processTabChangeForParts } from 'shared/product_tabs/tab_parts/slice/process_tab_change';

import {
  TAB_ACCESSORIES,
  TAB_ASSEMBLY,
  TAB_FABRICATION,
  TAB_STENCILS,
  TAB_PCB_PARTS,
} from 'shared/product_tabs/tabs/tabType';

const App = () => {
  const dispatch = useDispatch();
  const activeTab = useSelector(selectActiveTab);
  const zip_file_input_id = 'gerber-file';
  const fabrication_slug = 'offshore_pcbs';

  const onChangeTab = (key) => {
    dispatch(changeTab(key));
    dispatch(processTabChangeForParts(key));
  };

  useEffect(() => {
    dispatch(changeGlobalParameter({ name: 'zip_input_id', value: zip_file_input_id }));
    dispatch(changeGlobalParameter({name: 'fabrication_slug', value: fabrication_slug}));
  }, []);

  return (
    <>
      <div className="container-fluid project-information">
        <Project />
      </div>
      <Tab.Container
        id="tabs"
        activeKey={activeTab}
        onSelect={onChangeTab}
        defaultActiveKey={activeTab}>
        <div className="container-fluid tab-container">
          <div className="container">
            <Nav variant="tabs" className="flex-column flex-md-row">
              <Nav.Item className="p-0">
                <Nav.Link eventKey={TAB_FABRICATION}>
                  {Spree.translations.tab_fabrication}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="p-0 ml-md-2">
                <Nav.Link eventKey={TAB_ASSEMBLY}>
                  {Spree.translations.tab_assembly}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="p-0 ml-md-2">
                <Nav.Link eventKey={TAB_PCB_PARTS}>
                  {Spree.translations.tab_parts}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="p-0 ml-md-2">
                <Nav.Link eventKey={TAB_STENCILS}>
                  {Spree.translations.tab_stencils}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="p-0 ml-md-2">
                <Nav.Link eventKey={TAB_ACCESSORIES}>
                  {Spree.translations.tab_accessories}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
        </div>

        <div className="container px-0">
          <div className="tab-content-wrap">
            <ToasterComponent />
            <div className="container">
              <Tab.Content>
                <Tab.Pane eventKey={TAB_FABRICATION}>
                  <div className="pcb-fabrication py-2">
                    <Fabrication />
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey={TAB_ASSEMBLY}>
                  <div className="pcb-assembly py-2">
                    <Assembly />
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey={TAB_STENCILS}>
                  <div className="stencils py-4">
                    <Stencils />
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey={TAB_ACCESSORIES}>
                  <div className="accessories py-4">
                    <Accessories />
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey={TAB_PCB_PARTS}>
                  <div className="accessories py-4">
                    <Parts />
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};

export default App;
